import {registerRequestInterceptor, registerResponseInterceptor} from "@/Fwk/Http/comRequest";
import {AuthInterceptor} from "@/Fwk/Http/Interceptors/AuthInterceptor";
import {LogRequestInterceptor} from "@/Fwk/Http/Interceptors/LogRequestInterceptor";
import {LogResDataInterceptor} from "@/Fwk/Http/Interceptors/LogResDataInterceptor";
import {NetType} from "@/Fwk/Http/NetType";


export default class RequestMgr {
    static isInitOk = false;

    public static Init() {
        if (this.isInitOk)return;
        this.isInitOk = true;
        // 注册请求拦截器
        registerRequestInterceptor(AuthInterceptor);
        registerRequestInterceptor(LogRequestInterceptor);
        // 注册响应拦截器
        registerResponseInterceptor(LogResDataInterceptor);
    }

    public static getUrl(type: NetType):string {
        return type;
    }

}
